import { render, staticRenderFns } from "./35snow.vue?vue&type=template&id=0a03b268&scoped=true&"
import script from "./35snow.vue?vue&type=script&lang=js&"
export * from "./35snow.vue?vue&type=script&lang=js&"
import style0 from "./35snow.vue?vue&type=style&index=0&id=0a03b268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a03b268",
  null
  
)

export default component.exports